import { useState } from 'react'
import { Trans } from 'react-i18next'

import { OrgPermission } from '@makyoapp/makyo-sdk/models/ACL'
import { Button } from '@makyoapp/makyo-ui'

import { useOrgPerm } from '@/hooks/useOrgPerm'

import { BrandKitFontModal } from './BrandKitFontModal'

export function BrandKitFont() {
  const [modal, setModal] = useState('')
  const canEditBrandKit = useOrgPerm(OrgPermission.BrandKitEdit)

  return (
    <>
      <div className='w-full'>
        {canEditBrandKit && (
          <Button className='w-full' onClick={() => setModal('show')}>
            <Trans>Edit Font Settings</Trans>
          </Button>
        )}
      </div>
      {Boolean(modal) && <BrandKitFontModal show={modal} setShow={setModal} />}
    </>
  )
}
